import PropTypes from "prop-types";

import React, {
	Component
} from "react";
import {
	TouchableOpacity,
	StyleSheet,
	View,
} from "react-native";
import global from "global";
import Style from "ae-style";
import StyledIcon from "ae-base/Base/StyledIcon";
import StyledText from "ae-base/Base/StyledText";

var styles = StyleSheet.create({
	inputStyle: {
		flexDirection: "row",
		marginVertical: Style.layout.marginContentSmall / 2,
		marginLeft: Style.layout.marginSlim,
		marginRight: Style.layout.marginSmall,
		paddingVertical: Style.layout.paddingSmall / 2,
		alignItems: "center",
		alignSelf: "flex-start"

	},
	iconStyle: {
		borderColor: Style.look.text,
		marginRight: Style.layout.marginSmall
	}

});

export default class VideoPickerWeb extends Component {
	constructor(props){
		super(props);
		this.captureVideoWithCamera = captureVideoWithCamera.bind(this);
	}

	render(){
		var context = this.context;
		var props = this.props;
		var title = props.title;
		var id = props.id;
		if(!global.cordova || !global.Camera) return;

		return (
			<TouchableOpacity id={context.id_prefix + id} accessibilityComponentType="button" onPress={this.captureVideoWithCamera}>
				<View style={styles.inputStyle}>
					<StyledIcon style={styles.iconStyle}  large name="video-camera" />
					<StyledText  bold>
						{title}
					</StyledText>
				</View>
			</TouchableOpacity>
		);

	}
}

function captureVideoWithCamera() {
	var onAdd = this.props.onAdd;
	// capture callback
	var captureSuccess = function(mediaFiles) {
		var i, path, len, name;
		for (i = 0, len = mediaFiles.length; i < len; i += 1) {
			path = mediaFiles[i].fullPath;
			name = mediaFiles[i].name;
			// do something interesting with the file
			if(onAdd) onAdd({
				isCordova: true,
				url: path,
				isVideo: true,
				name: name
			});
		}
	};

	// capture error callback
	var captureError = function(error) {
		console.log("Error code: " + error.code, null, "Capture Error", error);
	};

	// start video capture
	global.navigator.device.capture.captureVideo(captureSuccess, captureError, {
		limit: 1,
	});
}

VideoPickerWeb.contextTypes = {
	id_prefix: PropTypes.string,
};
